import Vue from 'vue'
import Router from 'vue-router'
import chat from '@/pages/chat/chat'
import chat_list from '@/pages/chat_list/chat_list'
import doctor_content from "../pages/doctor/doctor_content";
import doctor_detail from "../pages/doctor/doctor_detail";
import doctor_list from "../pages/doctor/doctor_list";
import search from "../pages/search/search";
import patient_edit from "../pages/patient/patient_edit";
import patient_detail from "../pages/patient/patient_detail";
import address_edit from "../pages/address/address_edit";
import address_list from "../pages/address/address_list";
import order_pay from "../pages/order/order_pay";
import wenzhen_order_pay from "../pages/order/wenzhen_order_pay";
import patient_list from "../pages/patient/patient_list";
import index from "../pages/index/index";
import select_patient from "../pages/patient/select_patient";
import my from "../pages/user/my";
import pat_content from "../pages/user/pat_content";
import wenzhen_order_content from "../pages/order/wenzhen_order_content";
import bind_phone from "../pages/bind_phone/bind_phone";
import user_edit from "../pages/user/user_edit";
import my_doctor from "../pages/user/my_doctor";
import my_shop_car from "../pages/user/my_shop_car";
import my_issue from "../pages/user/my_issue";
import issue_detail from "../pages/user/issue_detail";
import up_photos from "../pages/user/up_photos";
import find_doctor from "../pages/find_doctor/find_doctor";
import order_pay_detail from "../pages/order/order_pay_detail";
import pdf from "../pages/pdf";
import doctor_main from '../pages/doctor/doctor_main'
import second_pay from '../pages/user/second_pay'
import shipin_order_pay from '../pages/order/shipin_order_pay'
import doctorCode from '../pages/doctorCode/doctorCode'
import download from '../pages/download/index'
import dislistpage from '../pages/dislistpage/dislistpage'
import patient_issue_info from '../pages/patient/patient_issue_info'
import guahao from '../pages/guahao/guahao'
import guahaoSuccess from '../pages/guahao/success'
import openMini from '../pages/openMini/openMini'
import store from '../store';
Vue.use(Router)

//cv以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{
        title:'大医健康'
      }
    },
    {
      path: '/find_doctor',
      name: 'find_doctor',
      component: find_doctor,
      meta:{
        title:'找名医'
      }
    },
    {
      path: '/second_pay',
      name: 'second_pay',
      component: second_pay,
      meta:{
        title:'购买服务'
      }
    },
    {
      path: '/doctor_main',
      name: 'doctor_main',
      component: doctor_main,
      meta:{
        title:'医生主页'
      }
    },
    {
      path: '/chat',
      name: 'chat',
      component: chat
    },
    {
      path: '/chat_list',
      name: 'chat_list',
      component: chat_list,
      meta:{
        title:'消息'
      }
    },
    {
      path: '/doctor_content',
      name: 'doctor_content',
      component: doctor_content,
      meta:{
        title:'医生详情'
      }
    },
    {
      path: '/doctor_detail',
      name: 'doctor_detail',
      component: doctor_detail,
      meta:{
        title:'医生详情'
      }
    },
    {
      path: '/doctor_list',
      name: 'doctor_list',
      component: doctor_list
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta:{
        title:'找名医'
      }
    },
    {
      path: '/patient_edit',
      name: 'patient_edit',
      component: patient_edit,
      meta:{
        title:'添加就诊人'
      }
    },
    {
      path: '/patient_detail',
      name: 'patient_detail',
      component: patient_detail,
      meta:{
        title:'就诊人详情'
      }
    },
    {
      path: '/address_edit',
      name: 'address_edit',
      component: address_edit
    },
    {
      path: '/address_list',
      name: 'address_list',
      component: address_list,
      meta:{
        title:'地址管理'
      }
    },
    {
      path: '/order_pay',
      name: 'order_pay',
      component: order_pay,
      meta:{
        title:'订单详情'
      }
    },
    {
      path: '/wenzhen_order_pay',
      name: 'wenzhen_order_pay',
      component: wenzhen_order_pay,
      meta:{
        title:'购买服务'
      }
    },
    {
      path: '/patient_list',
      name: 'patient_list',
      component: patient_list,
      meta:{
        title:'常用就诊人'
      }
    },
    {
      path: '/order_pay_detail',
      name: 'order_pay_detail',
      component: order_pay_detail,
      meta:{
        title:'订单详情'
      }
    },
    {
      path: '/select_patient',
      name: 'select_patient',
      component: select_patient
    },
    {
      path: '/my',
      name: 'my',
      component: my,
      meta:{
        title:'我的'
      }
    },
    {
      path: '/user_edit',
      name: 'user_edit',
      component: user_edit,
      meta:{
        title:'编辑'
      }
    },
    {
      path: '/my_doctor',
      name: 'my_doctor',
      component: my_doctor,
      meta:{
        title:'我的医生'
      }
    },
    {
      path: '/my_shop_car',
      name: 'my_shop_car',
      component: my_shop_car,
      meta:{
        title:'我的购药'
      }
    },
    {
      path: '/my_issue',
      name: 'my_issue',
      component: my_issue,
      meta:{
        title:'我的问诊'
      }
    },
    {
      path: '/issue_detail',
      name: 'issue_detail',
      component: issue_detail,
      meta:{
        title:'订单详情'
      }
    },
    {
      path: '/pat_content',
      name: 'pat_content',
      component: pat_content,
      meta:{
        title:'患者信息'
      }
    },
    {
      path: '/wenzhen_order_content',
      name: 'wenzhen_order_content',
      component: wenzhen_order_content
    },
    {
      path: '/bind_phone',
      name: 'bind_phone',
      component: bind_phone
    },
    {
      path: '/up_photos',
      name: 'up_photos',
      component: up_photos,
      meta:{
        title:'上传资料'
      }
    },
    {
      path: '/shipin_order_pay',
      name: 'shipin_order_pay',
      component: shipin_order_pay,
      meta:{
        title:'视频问诊'
      }
    },{
      path: '/doctorCode',
      name: 'doctorCode',
      component: doctorCode,
      meta:{
        title:'医生分享'
      }
    },
    {
      path: '/pdf_template',
      name: 'pdf_template',
      component: pdf
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/dislistpage',
      name: 'dislistpage',
      component: dislistpage
    },
    {
      path: '/patient_issue_info',
      name: 'patient_issue_info',
      component: patient_issue_info
    },
    {
      path: '/guahao',
      name: 'guahao',
      component: guahao,
      meta:{
        title:'订单详情'
      }
    },
    {
      path: '/guahaoSuccess',
      name: 'guahaoSuccess',
      component: guahaoSuccess,
      meta:{
        title:''
      }
    },
    {
      path: '/o',
      name: 'openMini',
      component: openMini,
      meta:{
        title:''
      }
    }
  ]
})
router.beforeEach((to,from,next)=>{
  console.log(from,'from',to,'to')
  let data = {
    path:from.path,
    query:from.query,
    params:from.params
  }
  store.dispatch('getRouterBack',data);
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js